import React from "react";
import { Box } from "@material-ui/core";

import { Navbar, Footer } from "../components";

import "../styles/index.scss";

function Layout({ children }) {
  return (
    <Box minHeight="100vh" width="100vw" display="flex" flexDirection="column">
      <Navbar />
      <Box flex={1}>{children}</Box>
      <Footer />
    </Box>
  );
}

export default Layout;
